import reasonViewerTopicparameter from "utils/issues/reason_viewer_topicparameter";

function getDefaultIssueRuleValues(rules) {
  return [
    {
      path: `topics.[${rules.topic_id}].[${rules.parameter_id}]`,
      value: "",
    },
  ];
}

export default {
  reasonViewer: reasonViewerTopicparameter,
  getDefaultIssueRuleValues,
};
